import { routes as clinicRoutes } from "./clinics/routes";
import { routes as labSetupRoutes } from "./lab-setup/routes";
import { routes as consultantsRoutes } from "./consultants/routes";
import { routes as wardsRoutes } from "./wards/routes";
import { routes as morgueRoutes } from "./morgue/routes";
import { routes as theatreRoutes } from "./theatre/routes";
import { routes as employeeRoutes } from "./employee-setup/routes";
import { routes as geoRoutes } from "./geographic/routes";
import { routes as organizationRoutes } from "./organizations/routes";
import { routes as itemSetupRoutes } from "./items-setup/routes";
import { routes as questionaireRoutes } from "./questionaires/routes";
import { routes as imagingRoutes } from "./imaging/routes";
import { routes as immunizationRoutes } from "./immunization/routes";
import { routes as vitalsRoutes } from "./vitals-params/routes";
import { routes as templateRoutes } from "./templates/routes";
import { routes as accountsMasterData } from "./accounts-master-data/routes";
import { routes as voucherDeductionsRoutes } from "./voucher-deductions/routes";
import { routes as customMessagesRoutes } from "./custom-messages/routes";
import { routes as itemcollectionRoutes } from "./item-collection/routes";
import { routes as hospitalDocumentsRoutes } from "./hospital-docs/routes";
import { routes as departmentchargesRoutes } from "./Departments/routes";
export const routes = [
    {
        name: `master-data.index`,
        path: `/master-data`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `master-data.index`,
                PageDescription: "Master data: System configurations",
            },
        },
    },
    ...clinicRoutes(`master-data`),
    ...labSetupRoutes(`master-data`),
    ...consultantsRoutes(`master-data`),
    ...wardsRoutes(`master-data`),
    ...morgueRoutes(`master-data`),
    ...theatreRoutes(`master-data`),
    ...employeeRoutes(`master-data`),
    ...geoRoutes(`master-data`),
    ...organizationRoutes(`master-data`),
    ...itemSetupRoutes(`master-data`),
    ...questionaireRoutes(`master-data`),
    ...imagingRoutes(`master-data`),
    ...immunizationRoutes(`master-data`),
    ...vitalsRoutes(),
    ...templateRoutes(),
    ...accountsMasterData(`master-data`),
    ...voucherDeductionsRoutes(`master-data`),
    ...customMessagesRoutes(`master-data`),
    ...itemcollectionRoutes(`master-data`),
    ...hospitalDocumentsRoutes(`master-data`),
    ...departmentchargesRoutes(`master-data`),
];
